import { render } from "./CollapsiblePanel.vue?vue&type=template&id=27158b50&scoped=true"
import script from "./CollapsiblePanel.vue?vue&type=script&lang=js"
export * from "./CollapsiblePanel.vue?vue&type=script&lang=js"

import "./CollapsiblePanel.vue?vue&type=style&index=0&id=27158b50&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27158b50"]])

export default __exports__